import { useDispatch, useSelector } from "react-redux";
import { useParams  } from "react-router";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import FormikControl from "../../bmr/components/common/FormikControl";
import { LoadingButton } from "@mui/lab";
import { markedAsDispatched } from "../../bmr/slices/common";
import { fetchAllActiveDeliveryPartners, selectDeliveryActivePartnersAll } from "../../bmr/slices/deliveryPartners";
import React, { useEffect, useMemo, useState } from 'react';

const initialValues = {
  delivery_partner_id: "",
  awb: "", // Changed from awb_number to awb
  tracking_link: "",
};

const validationSchema = Yup.object().shape({
  delivery_partner_id: Yup.string().required("Delivery Partner is required"),
  awb: Yup.string() // Changed from awb_number to awb
    .required("AWB Number is required")
    .max(150, "Maximum of 150 characters"),
  tracking_link: Yup.string()
    .url("Tracking Link must be a valid URL")
    .nullable()
    .notRequired()
    .test(
      "is-empty-or-valid-url",
      "Tracking Link must be a valid URL",
      (value) => !value || Yup.string().url().isValidSync(value)
    ),
});

const MarkedAsDispatched = ({ 
  handleFormSubmit = () => { }, 
  feasibility_id,
  initialValues: propInitialValues, // Add this prop
  fieldStates = {}, // Add this prop
}) => {
  const dispatch = useDispatch();
  const { subjectId } = useParams();
  const deliveryPartnerOptions = useSelector(selectDeliveryActivePartnersAll) || []
 const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const fetchAll = async () => {
      await dispatch(fetchAllActiveDeliveryPartners())
    };
    fetchAll();
  }, [dispatch]);

const formOptions = useMemo(() => {
  return [
    {
      type: "select",
      label: "Delivery Partner",
      name: "delivery_partner_id",
      options: deliveryPartnerOptions,
      required: true,
      placeholder: "Select partner",
      disabled: fieldStates?.delivery_partner_id || false,
    },
    {
      label: "AWB Number",
      type: "text",
      name: "awb",
      required: true,
      placeholder: "Enter AWB number",
      disabled: fieldStates?.awb || false,
    },
    {
      label: "Tracking Link",
      type: "text",
      name: "tracking_link",
      required: false,
      placeholder: "Enter Tracking Link",
      disabled: fieldStates?.tracking_link || false,
    },
  ];
}, [fieldStates, deliveryPartnerOptions]);

  const handleSubmit = async (values) => {
     const payload = {
    patient_id: subjectId,
    feasibility_id: feasibility_id,
    data: {
      delivery_partner_id: values.delivery_partner_id,
      awb_number: values.awb, // Send as awb_number to API
      tracking_link: values.tracking_link,
    //  cr_id: fieldStates?.cr_id
    },
  };
      setIsSubmitting(true);
    try {
      const res = await dispatch(markedAsDispatched(payload)).unwrap();

      if (res.status === 200) {
        handleFormSubmit();
      }
    } catch (err) {
      console.error(err);
    }
      finally {
    setIsSubmitting(false);
  }
  };

  const getInitialValues = () => {
    if (propInitialValues && Object.keys(propInitialValues).length > 0) {
      return {
        delivery_partner_id: propInitialValues.delivery_partner_id?.toString() || "",
        awb: propInitialValues.awb || "",
        tracking_link: propInitialValues.tracking_link || "",
      };
    }
    return initialValues;
  };

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton fullWidth type="submit" variant="contained" loading={isSubmitting}
              disabled={isSubmitting}>
              {Object.keys(fieldStates).length > 0 ? "Approve & Update" : "Submit"}
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default MarkedAsDispatched;